exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".purchaseModal .modal-dialog{display:flex;justify-content:center;align-items:center;height:auto;width:50%;min-height:0}.purchaseModal .modal-content{height:100%;width:100%}.purchaseModal .modalItem{margin-top:5%;margin-bottom:5%}.purchaseModal .controls{display:flex;justify-content:center;gap:2em;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/games/purchase_modal.scss
// module id = 843
// module chunks = 0